import { faClock, faListCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import ReminderTable from "../Reminders/ReminderTable";
import LeadsTable from "../Leads/LeadsTable";
import Tasks from "./Tasks";

const AllTabs = () => {
  return (
    <div className="card-body ">
      <ul className="nav nav-tabs nav-justified transaction-tab mb-2">
        <li className="nav-item">
          <Link className="nav-link active" to="#Tasks" data-bs-toggle="tab">
            <FontAwesomeIcon icon={faListCheck} className="me-2" />
            My Tasks
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="#Remainders" data-bs-toggle="tab">
            <FontAwesomeIcon icon={faClock} className="me-2" />
            My Reminders
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="#Leads" data-bs-toggle="tab">
            <FontAwesomeIcon icon={faClock} className="me-2" />
            My Leads
          </Link>
        </li>
      </ul>
      <div className="tab-content">
        <div className="tab-pane show active" id="Tasks">
          <Tasks />
        </div>
        <div className="tab-pane" id="Remainders">
          <ReminderTable />
        </div>
        <div className="tab-pane" id="Leads">
          <LeadsTable />
        </div>
      </div>
    </div>
  );
};

export default AllTabs;
